// A per-device switch that hides the "View as" button from the top bar, so a non-production screen can be
// screenshotted without the dev control in it. The build-time `SCREENSHOT_MODE` does the same for the native
// wrapper; this is the runtime version, flipped from Settings › Account.
//
// NON-PRODUCTION ONLY by construction: the toggle renders only where the switcher is offered at all
// (`useCanSwitchFixtureAccounts`), and the stored value is ignored in a production lane. Hiding the button
// changes nothing else — a swapped session stays swapped, and a reload still returns you to yourself.
// Stored in a small non-auth cookie for the same reason the theme preference is: localStorage is lint-banned.
import { create } from "zustand";
import { IS_NON_PRODUCTION } from "../config/env.js";

const COOKIE_NAME = "cntrl_hide_view_as";

function readStored(): boolean {
  if (!IS_NON_PRODUCTION || typeof document === "undefined") return false;
  return /(?:^|;\s*)cntrl_hide_view_as=1(?:;|$)/.test(document.cookie);
}

function writeStored(hidden: boolean): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COOKIE_NAME}=${hidden ? "1" : "0"}; path=/; max-age=31536000; samesite=lax`;
}

interface FixtureSwitchVisibilityState {
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
}

export const useFixtureSwitchVisibility = create<FixtureSwitchVisibilityState>((set) => ({
  hidden: readStored(),
  setHidden: (hidden) => {
    if (!IS_NON_PRODUCTION) return;
    writeStored(hidden);
    set({ hidden });
  },
}));
